import { AnyAction } from '@reduxjs/toolkit'

import {
  BULK_ADD_USERS_ERROR,
  BULK_ADD_USERS_SUCCESS,
  BULK_FINISHED_PROCESSING,
  BULK_RESET,
  BULK_SET_USER_LIST,
  BULK_START_PROCESSING
} from './actionTypes'

type OrganizationUsersBulkAddPageState = {
  isProcessingCsv: boolean
  usersToAdd: any[]
  created: any[]
  failed: any[]
  info: any[]
  csvData: any[][]
}

const initialState: OrganizationUsersBulkAddPageState = {
  isProcessingCsv: false,
  usersToAdd: [],
  created: [],
  failed: [],
  info: [],
  csvData: [[]]
}

export default (state = initialState, action: AnyAction): OrganizationUsersBulkAddPageState => {
  switch (action.type) {
    case BULK_START_PROCESSING: {
      return {
        ...state,
        csvData: action.csvData,
        usersToAdd: [],
        created: [],
        failed: [],
        info: [],
        isProcessingCsv: true
      }
    }
    case BULK_FINISHED_PROCESSING: {
      return {
        ...state,
        isProcessingCsv: false
      }
    }
    case BULK_ADD_USERS_SUCCESS: {
      if (action.response) {
        const csvLinesAffected = Object.fromEntries(action.response.map((r: any) => [r.data._meta.index, true]))
        return {
          ...state,
          usersToAdd: state.usersToAdd.filter(u => !csvLinesAffected[u._meta.index]),
          created: [
            ...state.created,
            ...action.response
              .filter((r: any) => r.status === 'success')
              .map((r: any) => ({
                type: 'email',
                readableType: 'email',
                readableValue: r.data.email,
                data: r.data,
                id: r.data.id
              }))
          ],
          info: [
            ...state.info,
            ...action.response
              .filter(
                (r: any) =>
                  r.status !== 'success' &&
                  (r.code === 'USERERROR-2' || r.data.errors.some((e: { code: string }) => e.code === 'USERERROR-2'))
              )
              .map((r: any) => ({
                type: 'email',
                readableType: 'email',
                readableValue: r.data.email,
                message: r.data.errors.map((e: { message: string }) => e.message).join(', '),
                data: r.data
              }))
          ],
          failed: [
            ...state.failed,
            ...action.response
              .filter(
                (r: any) =>
                  r.status !== 'success' &&
                  r.code !== 'USERERROR-2' &&
                  r.data.errors.filter((e: { code: string }) => e.code === 'USERERROR-2').length === 0
              )
              .map((r: any) => ({
                type: 'email',
                readableType: 'email',
                readableValue: r.data.email,
                message: r.data.errors.map((e: { message: string }) => e.message).join(', '),
                data: r.data
              }))
          ]
        }
      } else {
        return { ...state }
      }
    }

    case BULK_ADD_USERS_ERROR: {
      const csvLinesAffected = Object.fromEntries(action.users.map((u: any) => [u._meta.index, true]))
      return {
        ...state,
        usersToAdd: state.usersToAdd.filter(u => csvLinesAffected[u._meta.index]),
        failed: [
          ...state.failed,
          ...action.users.map((r: any) => ({
            type: 'email',
            readableType: 'email',
            readableValue: r.email,
            message: 'Error in service while adding user',
            data: r
          }))
        ]
      }
    }

    case BULK_SET_USER_LIST: {
      return { ...state, usersToAdd: action.usersToAdd || [] }
    }
    case BULK_RESET: {
      return {
        ...state,
        created: [],
        failed: [],
        info: [],
        csvData: action.isProcessingCsv ? [...state.csvData] : [[]],
        isProcessingCsv: action.isProcessingCsv || false
      }
    }
    default: {
      return state
    }
  }
}
